

import Vue from 'vue'
import Component from "vue-class-component";

import {Prop, Watch} from "vue-property-decorator";
import {IServiceProvider} from "@/model/Service/serviceProviderInterfaces";
import ImageUploader from "@/components/shared/ImageUploader.vue";

@Component({
  components: {ImageUploader}
})
export default class V2SpFormCardLayout extends Vue {
  @Prop()
  public title!: string;

  @Prop()
  public subTitle!: string;

  @Prop()
  public alert!: boolean;

  @Prop()
  public isEdit!: boolean;

  @Prop(  { default: false })
  public disabled!: boolean;

  @Prop(  { default: false })
  public fullSize!: boolean;
}

